import { Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import genericStyles from 'utils/genericStyles'

// Shown when a signed-in user's token carries no menus for their level. The header
// (and its Logout) still renders around this page, so the user is never trapped.
export const NoAccess = () => {
  const { t } = useTranslation()
  const genericClasses = genericStyles()

  return (
    <div className={genericClasses.noAccessPageDiv}>
      <Paper className={genericClasses.noAccessPagePaper}>
        <Typography variant="h5" align="center">
          {t<string>('text.no_modules_title')}
        </Typography>
        <Typography variant="body1" align="center">
          {t<string>('text.no_modules_description')}
        </Typography>
      </Paper>
    </div>
  )
}

export default NoAccess
